module.exports = __webpack_public_path__ + "static/media/cube.7cb8cce4.svg";